import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useEditor,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import { lazy, useRef } from "react";
import { Product } from "../components";
import style from "./block.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Scrollbar } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";

SwiperCore.use([Scrollbar]);

const Inspector = lazy(() => import("./inspector.js"));

export const ProductInsert = ({
  products = [],
  productsProps,
  brandId,
  ...props
}) => {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();
  const swiperRef = useRef(null);
  const swiperScrollbarRef = useRef(null);

  const mobileBreakpointInt = style.mobileBreakpoint.slice(0, 3);
  const desktopBreakpointInt = style.desktopBreakpoint.slice(0, 4);

  const swiperSettings = {
    modules: [Scrollbar],
    slidesPerView: 2,
    spaceBetween: 10,
    scrollbar: {
      el: swiperScrollbarRef.current,
      draggable: true,
      hide: false,
    },
    breakpoints: {
      [mobileBreakpointInt]: {
        slidesPerView: 2,
        spaceBetween: 54,
      },
      [desktopBreakpointInt]: {
        slidesPerView: 3,
        spaceBetween: 54,
      },
    },
  };

  // Initialize the swiper with React refs
  const initSwiper = (swiper) => {
    // Delay execution for the refs to be defined
    setTimeout(() => {
      if (swiper?.destroyed) {
        return;
      }
      // Re-init scrollbar
      swiper.params.scrollbar.el = swiperScrollbarRef.current;
      swiper.scrollbar.destroy();
      swiper.scrollbar.init();
      swiper.scrollbar.setTranslate();
      swiper.scrollbar.updateSize();
    }, 1);
  };

  console.log("products", products);
  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.container}>
        {!isEditing ? (
          <Swiper ref={swiperRef} {...swiperSettings} onSwiper={initSwiper}>
            {products?.length > 0 &&
              products.map((product, i) => (
                <SwiperSlide key={i} className={style.slide}>
                  <Product
                    product={product}
                    className={style.product}
                    listInsert={true}
                  />
                </SwiperSlide>
              ))}
            <div ref={swiperScrollbarRef} className={style.scrollbar}></div>
          </Swiper>
        ) : (
          <div className={style.admin}>Products will be here (see preview)</div>
        )}
      </div>
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block: ProductInsert,
  setup: {
    title: "Product Insert (List)",
  },
  smartProps: {
    productsProps: smartProps.array.withDefault([]),
    brandId: smartProps.number.withDefault(-1),
  },
});
